import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

const styles = xcss({
	display: 'inline-block',
	font: 'font.body',
	color: 'color.text.subtlest',
	textDecoration: 'none',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
	overflow: 'hidden',
});

const SearchMetadataGeneric = ({ label }: { label: string }): React.JSX.Element => {
	return <Box xcss={styles}>{label}</Box>;
};

export default SearchMetadataGeneric;
